import React from 'react';
import { LayoutSectionElem } from '../../common/layout-section';
import { LayoutAppElem } from '../../common/layout-app';
import { LayoutElem } from '../../common/layout';
import { PageElem } from '../../common/page';
import { MenuAppContainer } from '../../epic/menu-app';
import icon from '../../asset/svg/header/project.svg';

import { ProjectListContainer } from '../../epic/project-list';
import { HeaderContainer } from '../../epic/header';

export const Page: React.FC = () => {
  return (
    <PageElem>
      <LayoutAppElem>
        <MenuAppContainer />

        <LayoutElem>
          <HeaderContainer icon={icon} title="PROJECT.TITLE" />

          <LayoutSectionElem spacing={8}>
            <ProjectListContainer />
          </LayoutSectionElem>
        </LayoutElem>
      </LayoutAppElem>
    </PageElem>
  );
};
